<div class="modal-content loader-parent stock-required-date-container">
  <div class="page-loader" [ngClass]="{'d-none': !isLoading}"></div>
  <form [formGroup]="carrierForm" (ngSubmit)="onSubmit()" id="carrier-form" ngbAutofocus="false">
    <!-- Modal body -->
    <div class="modal-body">
      <div class="quotes-model-inner">
        <h2 class="share-modal-title"> {{ quoteOrderModel.quote_schedule_delivery_id ? 'Schedule Delivery' : 'Choose Carrier' }} </h2>
        <p>{{!quoteOrderModel.quote_schedule_delivery_id ? 'Please select the prime carrier carrying out this delivery.' :''}} </p>
        <div class="email-selection-widget">
          <div class="free-order-address">
            <!-- <div class="form-group" *ngIf="is_split_delivery">
              <label>Products </label>
              <ng-select formControlName="product" class="form-control" [items]="productList" [virtualScroll]="true"
                bindLabel="search_keyboard" bindValue="id" placeholder="Select products" [clearable]="true"
                [multiple]="true">
                <ng-template ng-option-tmp let-item="item" let-item$="item$" let-index="index">
                  <div class="custom-control custom-checkbox">
                    <input id="item-{{ index }}" type="checkbox" [ngModel]="item$.selected"
                      [ngModelOptions]="{ standalone: true }" class="custom-control-input" />
                    <label class="custom-control-label" for="item-{{ index }}">
                      {{ item.search_keyboard }}
                    </label>
                  </div>
                </ng-template>
              </ng-select>
            </div> -->

            <div class="form-group">
              <label>Carrier <span class="required-field">{{ is_selected ? '' : '*' }}</span></label>
              <ng-select formControlName="carrier_id" class="form-control"
                [ngClass]="{ 'is-invalid': (carrierForm.controls['carrier_id']?.invalid && carrierForm.controls['carrier_id']?.touched || submitted) || cf.carrier_id?.errors?.apiError, 'is-valid' : !(carrierForm.controls['carrier_id']?.invalid)}"
                [items]="carriers" [virtualScroll]="true" bindLabel="company_name" bindValue="id"
                placeholder="Select carrier" [clearable]="false" [readonly]="is_selected"
                (change)="isSelectCarrier(cf.carrier_id.value)">
              </ng-select>
              <span class="invalid-feedback" role="alert"
                *ngIf="(carrierForm.controls['carrier_id'].invalid && carrierForm.controls['carrier_id'].touched || submitted)">
                <span *ngIf="cf.carrier_id.errors?.required">Select carrier.</span>
                <span *ngIf="cf.carrier_id.errors?.apiError">{{ cf.carrier_id.errors?.apiError }}</span>
              </span>
            </div>
            <div class="terms-conditions">
              <div class="accordion" id="accordionExample" *ngIf="!is_selected"
                [ngClass]="{'isselectcarrier':isCarrierSelected}">
                <div class="card-head" (click)="hideShowAddCarrierData()">
                  <h5 class="mb-0" [ngClass]="{'collapsed': !is_show_add_carrier}"
                    [attr.aria-expanded]="is_show_add_carrier" aria-controls="collapseThree">Add New Carrier<i class="fa fa-plus" aria-hidden="true"></i></h5>
                </div>
                <div id="collapseThree" class="conditions-details" [ngClass]="{'collapse': !is_show_add_carrier, 'show': is_show_add_carrier}"
                  aria-labelledby="headingThree">
                  <div class="card-body">
                    <div class="conditions-details-inner">
                      <div class="form-group">
                        <label>Company Name <span class="required-field">*</span></label>
                        <input class="form-control" name="company_name" id="company_name"
                          [ngClass]="{ 'is-invalid': (cf.company_name.invalid && cf.company_name.touched || submitted) || cf.company_name.errors?.apiError, 'is-valid' : !(carrierForm.controls['company_name'].invalid)}"
                          formControlName="company_name" type="text" placeHolder="Enter Company Name">
                        <span class="invalid-feedback" role="alert"
                          *ngIf="(carrierForm.controls['company_name'].invalid && carrierForm.controls['company_name'].touched || submitted) || cf.company_name.errors?.apiError">
                          <span *ngIf="cf.company_name.errors?.required">Enter Company name.</span>
                          <span *ngIf="cf.company_name.errors?.apiError">{{ cf.company_name.errors?.apiError }}</span>
                        </span>
                      </div>
                      <div class="form-group">
                        <label>Contact Name <span class="required-field">*</span></label>
                        <input class="form-control" name="contact_name" id="contact_name"
                          [ngClass]="{ 'is-invalid': (carrierForm.controls['contact_name'].invalid && carrierForm.controls['contact_name'].touched || submitted) || cf.contact_name.errors?.apiError, 'is-valid' : !(carrierForm.controls['contact_name'].invalid)}"
                          formControlName="contact_name" type="text" placeHolder="Enter Contact Name">
                        <span class="invalid-feedback" role="alert"
                          *ngIf="(carrierForm.controls['contact_name'].invalid && carrierForm.controls['contact_name'].touched || submitted) || cf.contact_name.errors?.apiError">
                          <span *ngIf="cf.contact_name.errors?.required">Enter contact name.</span>
                          <span *ngIf="cf.contact_name.errors?.apiError">{{ cf.contact_name.errors?.apiError }}</span>
                        </span>
                      </div>
                      <div class="form-group">
                        <label>Contact Mobile Number</label>
                        <input class="form-control" name="contact_mobile_number" id="contact_mobile_number"
                          [ngClass]="{ 'is-invalid': (carrierForm.controls['contact_mobile_number'].invalid && carrierForm.controls['contact_mobile_number'].touched || submitted) || cf.contact_mobile_number.errors?.apiError, 'is-valid' : !(carrierForm.controls['contact_mobile_number'].invalid)}"
                          formControlName="contact_mobile_number" type="text" placeHolder="Enter Contact Mobile Number"
                          numbersOnly maxlength="10">
                        <span class="invalid-feedback" role="alert"
                          *ngIf="(carrierForm.controls['contact_mobile_number'].invalid && carrierForm.controls['contact_mobile_number'].touched || submitted) || cf.contact_mobile_number.errors?.apiError">
                          <span *ngIf="cf.contact_mobile_number.errors?.required">Enter contact mobile number.</span>
                          <span
                            *ngIf="cf.contact_mobile_number.errors?.maxlength || cf.contact_mobile_number.errors?.minlength">Enter valid contact mobile phone.</span>
                          <span *ngIf="cf.contact_mobile_number.errors?.apiError">{{
                            cf.contact_mobile_number.errors?.apiError }}</span>
                        </span>
                      </div>
                      <div class="form-group">
                        <label>Despatch Email <span class="required-field">*</span></label>
                        <input class="form-control" name="dispatch_email" id="dispatch_email"
                          [ngClass]="{ 'is-invalid': (carrierForm.controls['dispatch_email'].invalid && carrierForm.controls['dispatch_email'].touched || submitted) || cf.dispatch_email.errors?.apiError, 'is-valid' : !(carrierForm.controls['dispatch_email'].invalid)}"
                          formControlName="dispatch_email" type="text" placeHolder="Enter Despatch Email">
                        <span class="invalid-feedback" role="alert"
                          *ngIf="(carrierForm.controls['dispatch_email'].invalid && carrierForm.controls['dispatch_email'].touched || submitted) || cf.dispatch_email.errors?.apiError">
                          <span *ngIf="cf.dispatch_email.errors?.required">Enter despatch email.</span>
                          <span *ngIf="cf.dispatch_email.errors?.email || cf.dispatch_email.errors?.pattern">Enter a valid despatch email.</span>
                          <span *ngIf="cf.dispatch_email.errors?.apiError">{{ cf.dispatch_email.errors?.apiError
                            }}</span>
                        </span>
                      </div>
                      <div class="form-group">
                        <label>Applicable Regions <span class="required-field">*</span></label>
                        <ng-select formControlName="applicable_regions" dropdownPosition="bottom"
                          class="form-control-custom"
                          [ngClass]="{ 'is-invalid': (carrierForm.controls['applicable_regions']?.invalid && carrierForm.controls['applicable_regions']?.touched || submitted) || cf.applicable_regions?.errors?.apiError, 'is-valid' : !(carrierForm.controls['applicable_regions']?.invalid)}"
                          [items]="regions" bindLabel="name" bindValue="id" [multiple]="true"
                          placeholder="Select Applicable Regions" [closeOnSelect]="false">
                          <ng-template ng-option-tmp let-item="item" let-item$="item$" let-index="index">
                            <div class="custom-control custom-checkbox">
                              <input id="item-{{index}}" type="checkbox" [ngModel]="item$.selected"
                                [ngModelOptions]="{standalone: true}" class="custom-control-input" />
                              <label class="custom-control-label">{{ item.name }}</label>
                            </div>
                          </ng-template>
                        </ng-select>

                        <span class="invalid-feedback" role="alert"
                          *ngIf="(carrierForm.controls['applicable_regions'].invalid && carrierForm.controls['applicable_regions'].touched || submitted) || cf.applicable_regions.errors?.apiError">
                          <span *ngIf="cf.applicable_regions.errors?.required">Select applicable regions.</span>
                          <span *ngIf="cf.applicable_regions.errors?.apiError">{{ cf.applicable_regions.errors?.apiError
                            }}</span>
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <label class="select-content-inner mb-20px">
                <div class="">
                  <input formControlName="own_transport" type="checkbox" data-md-icheck [checked]="is_selected"
                    (change)="toggleOwnTransportOption($event)">
                  <span class="checkmark" ng-model="isCarrierSelected" ng-disabled="isCarrierSelected"></span>
                </div>
                <p>Select this option when the customer is facilitating their own transport.</p>
              </label>

              @if(quoteOrderModel.quote_schedule_delivery_id) {
                <div class="form-group">
                  <label>Crates</label>
                  <input class="form-control" name="crates" formControlName="crates" type="text"
                    placeHolder="Enter Crates" numbersOnly maxlength="4">
                </div>

                <div class="form-group">
<!--                  <div class="d-flex align-items-center mb-2">-->
<!--                    <input type="checkbox" id="additional-delivery-charge" [checked]="is_selected_addtional_charge" (change)="additionalCharge($event)"-->
<!--                      class="mr-2" />-->
<!--                    <label class="mb-0" for="additional-delivery-charge">Additional Delivery Charges</label>-->
<!--                  </div>-->

                  <label class="select-content-inner mb-20px font-bold">
                    <div class="">
                      <input type="checkbox" data-md-icheck [checked]="is_selected_addtional_charge" (change)="additionalCharge($event)" [disabled]="is_selected">
                      <span class="checkmark"></span>
                    </div>
                    <p>Additional Delivery Charges</p>
                  </label>

                  <div *ngIf="is_selected_addtional_charge" class="form-group">
                    <!-- <input class="form-control" name="delivery_charges" formControlName="delivery_charges" type="text"
                      placeholder="Enter Delivery Charges" numbersOnly maxlength="5" /> -->
                      <div class="input-group">
                        <input type="text" class="form-control" formControlName="delivery_charges" placeholder="Enter Delivery Charges" numbersOnly maxlength="5" [readonly]="is_selected">
                        <div class="input-group-append">
                          <span class="input-group-text">$</span>
                      </div>
                      </div>
                      <span role="alert"
                        *ngIf="(carrierForm.controls['delivery_charges'].invalid && submitted)">
                        <span>Enter delivery charge.</span>
                      </span>
                  </div>
                </div>
              }
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="modal-footer">
      <button class="dark-bordered-btn" type="button" data-dismiss="modal" (click)="ngbActiveModal.close()">Cancel</button>
      <button type="submit" class="submit-btn-grey">Submit</button>
    </div>
  </form>
</div>
